import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import Scrollbar from "src/components/scrollbar";
import AssessmentTableColumn from "src/config/AssessmentTableColumn.config";
import StudentController from "src/controller/Student.controller";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function AssessmentReport({
  student_id,
  subject_code,
  student,
}) {
  const [report, setReport] = useState([]);
  const [tableHead, setTableHead] = useState([]);
  const [tableSubHead, setTableSubHead] = useState([]);
  const [tableBody, setTableBody] = useState([]);

  useEffect(() => {
    if (student_id && subject_code) {
      StudentController.getAssessmentReports(student_id, subject_code)
        .then((res) => setReport(res))
        .catch((err) => console.error(`Api Error: ${err.message}`));
    }
  }, [student_id, subject_code]);

  useEffect(() => {
    if (!(report.length > 2)) return;
    const tempHead = [...report[0]];
    tempHead?.shift();
    setTableHead(tempHead);

    const tempSubHead = [...report[1]];
    tempSubHead?.shift();
    tempSubHead?.shift();
    setTableSubHead(tempSubHead);

    const tempTableBody = [...report];
    tempTableBody?.shift();
    tempTableBody?.shift();
    setTableBody(tempTableBody);
  }, [report]);

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        py={1}
      >
        <Typography variant="h5" gutterBottom>
          Assessment Report
        </Typography>

        {/* <Button
          size="small"
          variant="contained"
          startIcon={<Iconify icon="solar:copy-bold-duotone" />}
          onClick={handleCopyPublicLink}
        >
          Public Link
        </Button> */}
      </Stack>
      <TableContainer>
        <Scrollbar>
          <Table
            size="small"
            sx={{ minWidth: 700 }}
            aria-label="customized table"
          >
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={2}>Cources</StyledTableCell>
                {tableHead.map((i) => (
                  <StyledTableCell
                    colSpan={2}
                    align="center"
                    sx={{ outline: "1px solid #fff" }}
                  >
                    {AssessmentTableColumn[i] ?? i}
                  </StyledTableCell>
                ))}
              </TableRow>

              <TableRow>
                <StyledTableCell
                  sx={{ minWidth: "220px", outline: "1px solid #fff" }}
                >
                  Topic
                </StyledTableCell>
                <StyledTableCell
                  sx={{ minWidth: "220px", outline: "1px solid #fff" }}
                >
                  Sub Topic
                </StyledTableCell>
                {tableSubHead.map((i) => (
                  <StyledTableCell
                    align="center"
                    sx={{ outline: "1px solid #fff" }}
                  >
                    {i}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableBody?.map((row, index) => (
                <StyledTableRow key={`${JSON.stringify(row)}_${index}`}>
                  {row?.map((i, index) => (
                    <StyledTableCell
                      sx={{ minWidth: "100px" }}
                      key={`${i}_${index}`}
                      align={index === 0 || index === 1 ? "left" : "center"}
                    >
                      {i}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </Scrollbar>
      </TableContainer>
    </Stack>
  );
}
